module.exports = __webpack_public_path__ + "img/us_bg_jiazhiguan@.59907be6.png";